// Free WhatsApp click-to-chat sharing (no API keys). Opens WhatsApp with a
// pre-filled message the user just presses send on.
export function shareWhatsApp(phone, message) {
  const digits = (phone || "").replace(/\D/g, "");
  const base = digits ? `https://wa.me/${digits}` : "https://wa.me/";
  window.open(`${base}?text=${encodeURIComponent(message)}`, "_blank");
}
